var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"d-flex flex-column"},[_c('Hero'),_c('Cards'),_c('Places'),_c('TryHosting'),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }